import React from "react" // eslint-disable-line no-unused-vars
import injectSheet from "react-jss" // eslint-disable-line no-unused-vars
import cn from "classnames" // eslint-disable-line no-unused-vars
import { LineChart } from "@/components"
import {
  onlyfyFullTheme,
  xingTheme,
  useIsRebrandingEnabled,
} from "@xingternal/rebranding-adapter"

const miniChartColors = (product, enableXingRebranding) => {
  const products = {
    default: {
      backgroundColor: "#ffffff",
      borderColor: onlyfyFullTheme.colors[360],
      pointHoverBackgroundColor: onlyfyFullTheme.colors[360],
    },
    xtm: {
      backgroundColor: enableXingRebranding
        ? "rgba(28, 204, 132, 0.3)"
        : "#F2F2FF", // Violet 1
      borderColor: enableXingRebranding
        ? xingTheme.colors.mint
        : onlyfyFullTheme.colors.xtm,
      pointHoverBackgroundColor: enableXingRebranding
        ? xingTheme.colors.mint
        : onlyfyFullTheme.colors.xtm,
    },
    xtp: {
      backgroundColor: enableXingRebranding
        ? "rgba(198, 241, 109, 0.3)"
        : "#F4F8FF", // Blue 1
      borderColor: enableXingRebranding
        ? xingTheme.colors.xingLime2
        : onlyfyFullTheme.colors.xtp,
      pointHoverBackgroundColor: enableXingRebranding
        ? xingTheme.colors.xingLime2
        : onlyfyFullTheme.colors.xtp,
    },
    ebp: {
      backgroundColor: enableXingRebranding
        ? "rgba(212, 105, 158, 0.3)"
        : "#FCFFEB", // Lime 1
      borderColor: enableXingRebranding
        ? "#D4699E"
        : onlyfyFullTheme.colors.xbm,
      pointHoverBackgroundColor: enableXingRebranding
        ? "#D4699E"
        : onlyfyFullTheme.colors.xbm,
    },
  }

  return products[product]
}

const styles = {
  chart: { marginBottom: -8 },
}

const defaultOptions = (tooltipFormatter, title) => ({
  legend: {
    position: "bottom",
    display: true,
    labels: {
      fontSize: 0,
      padding: 0,
      boxWidth: 0,
    },
  },
  title: {
    display: true,
    lineHeight: 0,
    padding: 2,
  },
  scales: {
    xAxes: [{ display: false }],
    yAxes: [{ display: false }],
  },
  tooltips: tooltipFormatter && {
    callbacks: {
      label: (tooltipItems) =>
        `${tooltipFormatter(tooltipItems.yLabel)} ${title}`,
    },
  },
})

const defaultDatasetOptions = {
  borderCapStyle: "round",
  borderColor: onlyfyFullTheme.colors.blue10,
  borderWidth: 2,
  lineTension: 0.4,
  pointBackgroundColor: "transparent",
  pointBorderColor: "transparent",
  pointBorderWidth: 0,
  pointHoverBackgroundColor: onlyfyFullTheme.colors.blue10,
  pointHoverBorderColor: "white",
  pointHoverBorderWidth: 2,
  pointHoverRadius: 4,
  pointHitRadius: 4,
  spanGaps: true,
}

const parseData = (payload, product, enableXingRebranding) => {
  payload.datasets.forEach((dataset, i) => {
    payload.datasets[i] = {
      ...defaultDatasetOptions,
      ...miniChartColors(product, enableXingRebranding),
      ...dataset,
      data: dataset.data.map((x) => x || 0),
    }
  })

  return payload
}

const parseOptions = (opts, tooltipFormatter, title) => ({
  ...defaultOptions(tooltipFormatter, title),
  ...opts,
})

const MiniLineChart = ({
  className,
  classes,
  data,
  height,
  options,
  title,
  tooltipFormatter,
  product,
}) => {
  const { enableXingRebranding } = useIsRebrandingEnabled()

  return (
    <LineChart
      className={cn(classes.chart, className)}
      data={parseData(data, product, enableXingRebranding)}
      options={parseOptions(options, tooltipFormatter, title)}
      height={height}
    />
  )
}

MiniLineChart.defaultProps = {
  classes: {},
  height: 36,
  product: "default",
}

export const StyledMiniLineChart = injectSheet(styles)(MiniLineChart)
export default MiniLineChart
